export const invertHexColor = (hex: string) => {
  // 색상 값이 #을 포함하는 경우 제거합니다.
  hex = hex.replace("#", "");

  // 16진수 색상 값을 10진수로 변환합니다.
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // 각 RGB 컴포넌트를 반전시킵니다.
  const invertedR = (255 - r).toString(16).padStart(2, "0");
  const invertedG = (255 - g).toString(16).padStart(2, "0");
  const invertedB = (255 - b).toString(16).padStart(2, "0");

  // 반전된 색상 값을 16진수 문자열로 반환합니다.
  return `#${invertedR}${invertedG}${invertedB}`;
};
